import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function Values() {
  const { t } = useTranslation();
  const [titleRef, titleVisible] = useScrollAnimation();
  const [headingRef, headingVisible] = useScrollAnimation();
  const [card1Ref, card1Visible] = useScrollAnimation();
  const [card2Ref, card2Visible] = useScrollAnimation();
  const [card3Ref, card3Visible] = useScrollAnimation();
  const [card4Ref, card4Visible] = useScrollAnimation();

  return (
    <div className="values-wrapper">
      <div className="values container">
        <div 
          ref={titleRef}
          className={`values-title flex ${titleVisible ? "animate-in" : ""}`}
        >
          <div className="circle"></div>
          <h4 className="clr-green fs-700">{t("values.ourValues")}</h4>
        </div>
        <h2 
          ref={headingRef}
          className={`fs-1000 clr-dark ${headingVisible ? "animate-in" : ""}`}
        >
          {t("values.title")}
        </h2>
        <div className="values-grid">
          <div 
            ref={card1Ref}
            className={`values-card ${card1Visible ? "animate-in" : ""}`}
          >
            <img src="/assets/icons/valueOne.svg" alt="Quality Icon" />
            <h3 className="fs-800">{t("values.quality")}</h3>
            <p className="fs-400">
              {t("values.qualityDesc")}
            </p>
          </div>
          <div 
            ref={card2Ref}
            className={`values-card ${card2Visible ? "animate-in" : ""}`}
          >
            <img src="/assets/icons/valueTwo.svg" alt="Quality Icon" />
            <h3 className="fs-800">{t("values.innovation")}</h3>
            <p className="fs-400">
              {t("values.innovationDesc")}
            </p>
          </div>
          <div 
            ref={card3Ref}
            className={`values-card ${card3Visible ? "animate-in" : ""}`}
          >
            <img src="/assets/icons/valueThree.svg" alt="Quality Icon" />
            <h3 className="fs-800">{t("values.integrity")}</h3>
            <p className="fs-400">
              {t("values.integrityDesc")}
            </p>
          </div>
          <div 
            ref={card4Ref}
            className={`values-card ${card4Visible ? "animate-in" : ""}`}
          >
            <img src="/assets/icons/valueFour.svg" alt="Quality Icon" />
            <h3 className="fs-800">{t("values.excellence")}</h3>
            <p className="fs-400">
              {t("values.excellenceDesc")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Values;
